import {
  ChangeDetectionStrategy,
  Component,
  Injector,
  OnInit,
} from '@angular/core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { fromEvent, Observable } from 'rxjs';
import {
  auditTime,
  distinctUntilChanged,
  map,
  startWith,
} from 'rxjs/operators';
import { nativeCursors } from '../../../../../cross-team-shared/cursors/native-cursors';
import { getAnimationFrameScheduler } from '../../../../../cross-team-shared/misc-utils';
import { AbstractAnnotationStore } from '../../../../../outputs/annotation/annotation-shared/state/root/abstract-annotation-store';

const regex = /url\((.*)\)(.*), auto/;

@Component({
  selector: 'h3-zoom-panel-cursor',
  templateUrl: 'zoom-panel-cursor.component.html',
  styleUrls: ['zoom-panel-cursor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ZoomPanelCursorComponent
  extends DirectiveSuperclass
  implements OnInit
{
  cursor$!: Observable<{ url: string; transform?: string }>;

  constructor(
    private store: AbstractAnnotationStore,
    injector: Injector,
  ) {
    super(injector);
  }

  ngOnInit() {
    const mousePosition = this.store.state().mousePosition;
    this.cursor$ = fromEvent<MouseEvent>(document, 'mousemove').pipe(
      auditTime(0, getAnimationFrameScheduler()),
      map((event) => event.srcElement as Element),
      startWith(
        document.elementFromPoint(
          mousePosition?.clientPoint[0] || 0,
          mousePosition?.clientPoint[1] || 0,
        ) || document.documentElement,
      ),
      map((target) => getComputedStyle(target).getPropertyValue('cursor')),
      distinctUntilChanged(),
      map((cursor) => {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- missing typescript flag
        if (nativeCursors[cursor]) {
          return nativeCursors[cursor];
        }

        // parse custom cursor to extract url and position
        const matches = cursor.match(regex);
        const position = matches?.[2]?.trim().split(' ').join('px, -');
        const transform = position && `translate(-${position}px)`;
        return {
          url: `url(${matches?.[1]})`,
          transform,
        };
      }),
    );
  }
}
